<template>
  <v-layout row wrap>
    <v-flex class="mv__nav">
      <v-toolbar dense flat>
        <user-avatar
          :avatar="avatar"
          :username="username"
          :size="40"
          :onClick="openMyProfile"
          style="cursor:pointer;"
        />

        <v-toolbar-title class="text-sm-center mv-title">
          <span v-if="$store.getters.isOnline">{{ username }}</span>
          <span v-else>{{ $t("status_connecting") }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-menu bottom offset-y>
          <v-btn icon slot="activator" class="mv-menu">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <template v-for="(item, index) in menu">
              <v-list-tile
                v-if="item.title !== undefined"
                :key="index"
                @click="menuItemClicked(item.key)"
              >
                <v-list-tile-title v-bind:class="item.class">{{
                  item.title
                }}</v-list-tile-title>
              </v-list-tile>
              <v-divider v-else :key="index" />
            </template>
          </v-list>
        </v-menu>
      </v-toolbar>

      <logout-dialog :visible.sync="logoutDialog"></logout-dialog>

      <profile-drawer />
      <navigation-view ref="nav" />
    </v-flex>

    <v-flex class="mv__chat">
      <chat-view ref="chat" />
    </v-flex>

    <settings :visible.sync="openSettings" ref="settings" />
    <about :visible.sync="aboutDialog" />
    <forward-message :visible.sync="openForward" :message.sync="forward" />
    <calling-dialog :visible.sync="openCall" ref="calling" />
    <contact-picker
      :visible.sync="pickContacts"
      :title="$t('choose_contact')"
      ref="contacts"
    />

    <v-snackbar
      v-model="showCoreMessage"
      :right="true"
      :timeout="5000"
      :top="true"
      color="secondary"
    >
      <span>{{ coreMessage }}</span>
      <v-btn icon @click="showCoreMessage = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <audio ref="audio" />
    <audio ref="audioChat" />

    <media-gallery
      :visible.sync="mediaGallery"
      :message="message"
      :progress="progress"
    />
  </v-layout>
</template>

<style>
.mv__nav {
  width: 325px;
}
.mv__chat {
  width: calc(100% - 325px);
}
.mv-title {
  /*margin-left:14px;*/
  user-select: none;
  /*font-size: 125% !important;*/
  font-weight: normal !important;
  color: var(--v-alternativeBackground-base);
}

.mv__nav .v-toolbar {
  padding: 3px 0;
  background-color: var(--nav-background) !important;
}
.mv__nav .v-toolbar__title:not(:first-child) {
  margin-left: 14px !important;
}

.mv-menu {
  color: var(--v-alternativeBackground-base) !important;
}

.v-menu__content .v-list {
  padding: 0 0 !important;
}
.v-menu__content .v-list__tile {
  height: 36px !important;
}
.v-menu__content .v-list__tile__title {
  font-size: 95%;
}

/* Fix toolbar items jumping during window resize */
.v-toolbar__content {
  height: 48px !important;
  padding: 0 16px !important;
}

/* Fix uppercase title of dialogs */
.v-card__title.title {
  text-transform: none !important;
}
.mv__exit-color {
  color: var(--v-primary-base) !important;
}

.mv__nav .v-btn {
  text-transform: none !important;
}
.mv__nav .v-btn::first-letter {
  text-transform: capitalize;
}
</style>

<script>
import NavigationView from "./NavigationView.vue";
import ChatView from "./ChatView.vue";
import Settings from "@settings/Settings.vue";
import UserAvatar from "@common/UserAvatar.vue";
import CallingDialog from "./call/CallingDialog.vue";
import ContactPicker from "@dialogs/ContactPicker.vue";
import ForwardMessage from "@dialogs/ForwardMessage.vue";
import LogoutDialog from "@dialogs/Logout.vue";
import About from "@dialogs/About.vue";
import ProfileDrawer from "./ProfileDrawer.vue";
import MediaGallery from "./MediaGallery.vue";

import { EventBus } from "@/event-bus";
import { Events } from "@/core-consts";
import { CallDirection } from "@/store/consts";
import coreStringsGetter from "@utils/coreStringsGetter";
import "@plugins/scroll/scroll-style.css";

const MenuId = {
  menu_settings: 0,
  menu_logout: 1,
  menu_about: 2,
  menu_exit: 3,
  menu_lock: 4,
  menu_support: 5,
};

export default {
  components: {
    Settings,
    ForwardMessage,
    NavigationView,
    ChatView,
    UserAvatar,
    CallingDialog,
    About,
    LogoutDialog,
    ContactPicker,
    ProfileDrawer,
    MediaGallery,
  },
  data() {
    return {
      username: "",
      avatar: "",
      menu: [],
      openSettings: false,
      aboutDialog: false,
      logoutDialog: false,
      openForward: false,
      openCall: false, // incoming call dialog
      forward: {},
      coreMessage: "",
      showCoreMessage: false,
      pickContacts: false,
      callDetails: false,
      mediaGallery: false,
      message: {},
      progress: 0,
    };
  },
  methods: {
    menuItemClicked(key) {
      switch (key) {
        case MenuId.menu_settings:
          this.openSettings = true;
          break;
        case MenuId.menu_logout:
          this.logoutDialog = true;
          break;
        case MenuId.menu_exit:
          this.$store.dispatch("exit");
          break;
        case MenuId.menu_about:
          this.aboutDialog = true;
          break;
        case MenuId.menu_support:
          this.$store.dispatch("openLink", "http://safeswiss.download/faq/");
          break;
        case MenuId.menu_lock:
          this.$store.dispatch("resetCurrentChat");
          this.$router.replace({ name: "PinDialog" });
          break;
        default:
          throw new Error("-- unknown key: " + key);
      }
    },
    openMyProfile() {
      // TODO: spinner?
      EventBus.$emit("open-my-profile");
    },
    userProfileChanged() {
      let p = this.$store.state.profile;
      this.avatar = p.avatar;
      this.username = p.name === "" ? p.id : p.name;
      console.log("-- userProfileChanged:", this.avatar);
    },
    chatChanged(args) {
      if (args.action === undefined)
        throw new Error("action is undefined: " + JSON.stringify(args));
      const chat = this.$store.state.currentChat;
      //console.log('-- chatChanged args: ' + JSON.stringify(args, null, ' '))

      switch (args.action) {
        case Events.ChatChanged:
        case Events.ChatDetailsChanged:
        case Events.ChatMessagesRemoved:
        case Events.FileSent:
        case Events.ChatMessageRemovedRemotely:
          this.$refs.nav.chatChanged(args);
          break;

        case Events.ChatMessageSendingDone:
          this.playChatSound(false);
          break;

        case Events.ChatMessageReceived:
        case Events.ChatMessageRemovedRemotely:
          this.$refs.nav.chatChanged(args);
          if (!document.hasFocus()) {
            //&& document.hidden
            this.showNotification(args.chatId, args.messageId);
          }
          // TODO: quick dirty fix to show unread alert in tray
          // TODO: remove from here when ChatUnreadChanged event will be a part of core
          this.$store.dispatch("unreadCountChanged");
          // TODO: no sense to be annoying when chat is opened
          this.playChatSound(true);
          break;
      }

      if (chat.chatId === args.chatId) this.$refs.chat.chatChanged(args);
    },
    chatDeleted(chatId) {
      this.$refs.nav.chatChanged(chatId);
    },
    chatTypingUpdated(args) {
      this.$refs.nav.chatTypingUpdated(args);
    },
    forwardChatMessage(messageId) {
      this.forward.chatId = this.$store.state.currentChat.chatId;
      this.forward.messageId = messageId;
      this.openForward = true;
    },
    updateTtlMessageProgress(args) {
      //console.log('-- main updateTtlMessageProgress: ' + JSON.stringify(args))
      if (args.progress != 0) this.$refs.chat.updateTtlMessageProgress(args);
    },
    openCallWindow() {
      this.openCall = true;
    },
    callChanged(args) {
      switch (args.action) {
        case Events.IncomingCall:
          const contactId = args.id;
          this.$store
            .dispatch("updateCallDirection", CallDirection.incoming)
            .then(() => {
              this.$refs.nav.recentChanged();
              this.$refs.calling.setCallerId(contactId);
              this.openCall = true;
            });
          break;
        case Events.ConferenceStarted:
          EventBus.$emit("conference-started");
          this.openCall = false;
          break;
        case Events.ConferenceEnded:
          this.$store
            .dispatch("updateCallDirection", CallDirection.unknown)
            .then(() => {
              this.$refs.nav.recentChanged();
              EventBus.$emit("conference-ended");
              this.openCall = false;
            });
          break;
        case Events.RecentChanged:
          this.$refs.nav.recentChanged();
          break;
        case Events.UserListChanged:
          EventBus.$emit("user-list-changed", args.users);
          break;
        case Events.ConferenceSuspended:
        case Events.ConferenceResumed:
          // TODO:
          break;
      }
    },
    playRingtone(id) {
      const player = this.$refs.audio;

      let ringtone = "1_ring_in.mp3";
      switch (this.$store.state.settings.callSound) {
        case "Standard":
          ringtone = "1_ring_in.mp3";
          break;
        case "Guitar":
          ringtone = "2_ring_in.mp3";
          break;
        case "Piano":
          ringtone = "3_ring_in.mp3";
          break;
      }

      if (id !== undefined) {
        const filename = id == 0 ? "warten.mp3" : ringtone;
        player.loop = true;
        player.src = require("@assets/sounds/" + filename);
        // fix of issue with "Autoplay Policy Changes"
        player.pause();
        player.currentTime = 0;
        setTimeout(() => player.play(), 0);
      } else {
        player.pause();
        player.src = "";
      }
    },
    playChatSound(incoming) {
      let filename = "";

      let s = this.$store.state.settings;
      if (incoming) {
        switch (s.incomingMessageSound) {
          case "Guitar":
            filename = "2_incoming.mp3";
            break;
          case "Piano":
            filename = "3_incoming.mp3";
            break;
          default:
            filename = "1_incoming.mp3";
            break;
        }
      } else {
        switch (s.outgoingMessageSound) {
          case "Guitar":
            filename = "2_outgoing.mp3";
            break;
          case "Piano":
            filename = "3_outgoing.mp3";
            break;
          default:
            filename = "1_outgoing.mp3";
            break;
        }
      }

      const player = this.$refs.audioChat;
      // check audio state to prevent multiple sounds
      if (!player.paused && !player.ended) return;
      player.src = "@assets/sounds/" + filename;
      player.loop = false;
      player.pause();
      player.currentTime = 0;
      setTimeout(() => player.play(), 0);
    },
    showMessage(args) {
      const message = coreStringsGetter.getStringById(args.id);
      this.coreMessage = args.arg
        ? this.$t(message, [args.arg])
        : this.$t(message);
      this.showCoreMessage = true;
    },
    showNotification(chatId, messageId) {
      const muted = this.$store.getters.isChatMuted(chatId);
      if (muted) return;

      this.$store
        .dispatch("fetchChatMessage", { chatId, messageId })
        .then((m) => {
          let title = m.userName;
          let icon =
            m.userAvatar !== ""
              ? m.userAvatar
              : require("@assets/images/unknown.png");

          let chat = this.$store.state.chats.find((it) => it.chatId == chatId);
          if (chat.type == 2) {
            icon = require("@assets/images/app-icon.png");
            title = this.$t("app_name");
          }

          let notification = new Notification(title, {
            body: this.getNotificationText(m),
            icon: icon,
          });
          notification.onclick = (e) => {
            console.log("-- notification click", chatId);
            this.$store.dispatch("openChatById", chatId).then(() => {
              this.$refs.chat.focusChanged();
            });
          };
        });
    },
    getNotificationText(m) {
      let text = m.message;
      switch (m.type) {
        case this.types.ImageMessage:
          text = this.$t("chat_picture_received");
          break;
        case this.types.VideoMessage:
          text = this.$t("chat_video_received");
          break;
        case this.types.DocumentMessage:
          text = this.$t("chat_document_received");
          break;
        case this.types.AudioMessage:
          text = this.$t("chat_voice_received");
          break;
        case this.types.ContactMessage:
          text = this.$t("chat_contact_received");
          break;
        case this.types.LocationMessage:
          text = this.$t("chat_location_received");
          break;
        case this.types.TimerMessage:
          if (m.ttl > 0) {
            const ttl = this.getTimerString(m.ttl);
            text = this.$t("chat_timer_info", [m.userName, ttl]);
          } else {
            text = this.$t("chat_timer_info_cancel", [m.userName]);
          }
          break;
        case this.types.UserLeftMessage:
          text = this.$t("chat_menu_leave_chat_sys_msg", [m.userName]);
          break;
        case this.types.UserAddedMessage:
          let users = "";
          text.split("\n").forEach((userId) => {
            if (users != "") users += ", ";
            users += this.getContactName(userId);
          });
          text = this.$t("chat_menu_add_users_sys_msg", [m.userName, users]);
          break;
        case this.types.ChatDetailsMessage:
          if (m.extra.notificationType == 0) {
            text = this.$t("chat_title_changed", [
              m.userName,
              m.extra.chatTitle,
            ]);
          } else {
            text = this.$t("chat_image_changed", [m.userName]);
          }
          break;
        case this.types.RemoveMessage:
          if (m.sent)
            text = this.$t("message_deleted_notification", [m.userName]);
          else text = this.$t("message_you_deleted_notification");
          break;
      }
      return text;
    },
    openAddContact(contactId) {
      this.$refs.nav.openAddContact(contactId);
    },
    showMediaGallery(args) {
      this.message = args.message;
      this.progress = args.progress;
      this.mediaGallery = true;
    },
    contactBlocked(args) {
      if (args.state == 1) {
        this.$refs.nav.contactBlocked(args.id);
        if (this.$refs.settings) this.$refs.settings.contactBlocked(args.id);
      } else {
        this.showAlert(this.$t("core_data_update_failed"));
      }
    },
    contactUnblocked(args) {
      if (args.state == 1) {
        this.$refs.nav.contactUnblocked(args.id);
        if (this.$refs.settings) this.$refs.settings.contactUnblocked(args.id);
      } else {
        this.showAlert(this.$t("core_data_update_failed"));
      }
    },
    contactsChanged() {
      this.$refs.nav.contactsChanged();
    },
    showAlert(message) {
      this.coreMessage = message;
      this.showCoreMessage = true;
    },
    callInviteUsers(contacts) {
      this.$refs.contacts.setCallback((users) => {
        //console.log(users)
        if (this.$store.getters.isCallBusy)
          this.$store.dispatch("addUsersToCall", users);
      });
      this.$refs.contacts.exclude(contacts);
      this.pickContacts = true;
    },
    updateMenu(isPinSet) {
      this.menu = [
        { title: this.$t("drawer_settings"), key: MenuId.menu_settings },
        { title: this.$t("drawer_logout"), key: MenuId.menu_logout },
      ];
      if (isPinSet)
        this.menu.push({
          title: this.$t("security_lock"),
          key: MenuId.menu_lock,
        });

      this.menu.push({
        title: this.$t("drawer_support"),
        key: MenuId.menu_support,
      });
      this.menu.push({
        title: this.$t("drawer_about"),
        key: MenuId.menu_about,
      });
      this.menu.push({});
      this.menu.push({
        title: this.$t("exit_app_title"),
        key: MenuId.menu_exit,
        class: "mv__exit-color",
      });
    },
  },
  beforeMount() {
    console.log("-- main.vue beforeMount");
    this.$store.dispatch("fetchUserProfile").then((p) => {
      //console.log('-- user profile' + JSON.stringify(p))
      this.avatar = p.avatar;
      this.username = p.name === "" ? p.id : p.name;
    });
  },
  mounted() {
    if (!this.$store.getters.isOnline) {
      console.log("NOT ONLINE, REDIRECT");
      this.$router.push({ name: "Loader" });
    }
    this.$store.dispatch("isApplicationPinSet").then((isPinSet) => {
      this.updateMenu(isPinSet);
    });

    EventBus.$on("user-profile-changed", this.userProfileChanged);
    EventBus.$on("chat-changed", this.chatChanged);
    EventBus.$on("chat-deleted", this.chatDeleted);
    EventBus.$on("forward-chat-message", this.forwardChatMessage);
    EventBus.$on("chat-ttl-message-progress", this.updateTtlMessageProgress);
    EventBus.$on("open-call-window", this.openCallWindow);
    EventBus.$on("call-changed", this.callChanged);
    EventBus.$on("play-ringtone", this.playRingtone);
    EventBus.$on("show-message", this.showMessage);
    EventBus.$on("open-add-contact", this.openAddContact);
    EventBus.$on("show-mediagallery", this.showMediaGallery);
    EventBus.$on("contact-blocked", this.contactBlocked);
    EventBus.$on("contact-unblocked", this.contactUnblocked);
    EventBus.$on("contacts-changed", this.contactsChanged);
    EventBus.$on("call-invite-users", this.callInviteUsers);
    EventBus.$on("pin-changed", this.updateMenu);

    // TODO: remove it from here
    this.$store.dispatch("localizationChanged", [
      this.$t("drawer_exit"),
      this.$t("app_name"),
    ]);
  },
  beforeDestroy() {
    EventBus.$off("user-profile-changed");
    EventBus.$off("chat-changed");
    EventBus.$off("chat-deleted");
    EventBus.$off("forward-chat-message");
    EventBus.$off("chat-ttl-message-progress");
    EventBus.$off("open-call-window");
    EventBus.$off("call-changed");
    EventBus.$off("play-ringtone");
    EventBus.$off("show-message");
    EventBus.$off("open-add-contact");
    EventBus.$off("show-mediagallery");
    EventBus.$off("contact-blocked");
    EventBus.$off("contact-unblocked");
    EventBus.$off("contacts-changed");
    EventBus.$off("call-invite-users");
    EventBus.$off("pin-changed");
  },
};
</script>
